import FieldDefs from './SitePagesWithKeysFieldDefs'
import SitePagesWithKeysGny from './SitePagesWithKeysGny'
import {doLangFields, isGoogleGny} from '../../lib/ks-tools'

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data () {
        return {
            fields: doLangFields(this, "lang.report.sitepageswithkeys", isGoogleGny() ? SitePagesWithKeysGny : FieldDefs),
            sortOrder: [
                {
                    field: '__slot:url',
                    sortField: 'url',
                    direction: 'asc',
                }
            ],
            moreParams: {}
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
